export const mycaAuthConfig = {
  defaultUserId: 'MYCA Member',
  returnParam: 'mycaLogin',
  login: {
    client: {
      e1: 'https://dwww.americanexpress.com/en-us/account/blue/login',
      e1sl: 'https://dwww.americanexpress.com/en-us/account/blue/login',
      e2: 'https://qwww.americanexpress.com/en-us/account/blue/login',
      e2sl: 'https://qwww.americanexpress.com/en-us/account/blue/login',
      e3: 'https://americanexpress.com/en-us/account/blue/login',
      e3sl: 'https://americanexpress.com/en-us/account/blue/login'
    },
    server: {
      e1: 'https://dwww.americanexpress.com/en-us/account/blue/login',
      e1sl: 'https://dwww.americanexpress.com/en-us/account/blue/login',
      e2: 'https://qwww.americanexpress.com/en-us/account/blue/login',
      e2sl: 'https://qwww.americanexpress.com/en-us/account/blue/login',
      e3: 'https://americanexpress.com/en-us/account/blue/login',
      e3sl: 'https://americanexpress.com/en-us/account/blue/login'
    }
  },
  logout: {
    client: {
      e1: 'https://one-dev.americanexpress.com/en-us/account/logout',
      e1sl: 'https://one-dev.americanexpress.com/en-us/account/logout',
      e2: 'https://qwww.americanexpress.com/en-us/account/logout',
      e2sl: 'https://qwww.americanexpress.com/en-us/account/logout',
      e3: 'https://americanexpress.com/en-us/account/logout',
      e3sl: 'https://americanexpress.com/en-us/account/logout'
    },
    server: {
      e1: 'https://one-dev.americanexpress.com/en-us/account/logout',
      e1sl: 'https://one-dev.americanexpress.com/en-us/account/logout',
      e2: 'https://qwww.americanexpress.com/en-us/account/logout',
      e2sl: 'https://qwww.americanexpress.com/en-us/account/logout',
      e3: 'https://americanexpress.com/en-us/account/logout',
      e3sl: 'https://americanexpress.com/en-us/account/logout'
    }
  }
};
export const resolveMycaEnvironment = (hostname = (_globalThis$location => (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname)() ?? '') => {
  if (hostname.includes('-dev') || hostname === 'localhost') {
    return 'e1';
  }
  if (hostname.includes('-qa')) {
    return 'e2';
  }
  return 'e3';
};
export const resolveMycaLoginUrl = (runtime = 'client', hostname) => {
  var _mycaAuthConfig$login;
  const environment = resolveMycaEnvironment(hostname);
  return ((_mycaAuthConfig$login = mycaAuthConfig.login[runtime]) === null || _mycaAuthConfig$login === void 0 ? void 0 : _mycaAuthConfig$login[environment]) || mycaAuthConfig.login.client.e1;
};
export const resolveMycaLogoutUrl = (runtime = 'client', hostname) => {
  var _mycaAuthConfig$logou;
  const environment = resolveMycaEnvironment(hostname);
  return ((_mycaAuthConfig$logou = mycaAuthConfig.logout[runtime]) === null || _mycaAuthConfig$logou === void 0 ? void 0 : _mycaAuthConfig$logou[environment]) || mycaAuthConfig.logout.client.e1;
};